import React from "react";
import Tittle from "../Components/Tittle";
import ImageSection from "../Components/ImageSection";
import translate from "../Translation/i18nProvider/translate";

function AboutPage() {
  return (
    <div className="AboutPage">
      <Tittle title={translate("about_title")} />
      <ImageSection />
    </div>
  );
}

export default AboutPage;
